<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">派送專線</div>
            <div class="breadcrumb-item">不派送日期選擇設定</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <span style="margin-right:10px;font-family: PingFang SC;font-weight: bold;">不派送日期選擇設定</span>
                    <div class="pg-btn style2" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
				   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="time">
                    <el-date-picker 
                      :editable="false"
                      v-model="row.time"
                      type="date"
                      placeholder="請選擇日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      @change="handleEdit(row)">
                    </el-date-picker>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <!-- <div class="pg-btn style1" style="width:100px" @click="handleEdit(row)">確定修改</div> -->
                        <div class="pg-btn style1" style="width:100px" @click="handleDelete(row.id)">删除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <Modal v-model="isShowModalSign_goods"
               title="不派送日期選擇設定 (新增)"
               width="600"
               :footer-hide="true"
               @on-cancel="handleModalSignClose_goods">
            <div class="modal-cont">
               <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                    <div class="loading-text">Loading</div>
                </Spin>
                <div class="pg-form-wrap">
                    <Row>
                    <Col span="200" push="3">
                        <Form :label-width="150">
                            <Row>
                                <Col span="16">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>專線名稱</span>
                                        </div>
                                        <Select placeholder="請選擇專線名稱" v-model="form.did" style="width:100%">
                                            <Option :value="item.id" v-for="(item, index) in deliveryareaList"
                                                    :key="item.id">{{item.name}}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>不派送日期選擇</span>
                                        </div>
                                        <el-date-picker
                                          value-format="yyyy-MM-dd"
                                          type="dates"
                                          v-model="form.time"
                                          placeholder="選擇一個或多個日期">
                                        </el-date-picker>
                                    </FormItem>
                                    
                                    <FormItem>
                                        <div class="pg-btn-wrap">
                                            <div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
                                        </div>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                      </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                not_onduty_value: '',
                status: false, // 是否開啓
                isSubmiting: false,
                isShowModalSign_goods: false,
                isSubmitingLog: false,
                deliveryareaList: [],
				form: {
                    did: '',
				    time: '',
				},
                table: {
                    column: [
                        {
                            title: '序號',
                            key: 'id',
                            align: 'center',
							sortable: true,
                            minWidth: 20
                        },
						{
						    title: '專線序號',
						    key: 'did',
						    align: 'center',
							sortable: true,
						    minWidth: 20
						},
                        {
                            title: '時間數組',
                            key: 'time',
                            slot: 'time',
                            align: 'center',
							sortable: true,
                            minWidth: 200
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 50
                        }
                    ],
                    data: []
                }
            };
        },
        mounted() {
            this.pageParam = this.$route.query;
            if(this.pageParam.id == undefined || this.pageParam.id == "") {
                 this.getDeliveryareaList();
                 this.getList();
            }
            else {
                this.getDeliveryareaList();
                this.getList(this.pageParam.id);
            }
        },
        methods: {
            getDeliveryareaList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.deliveryareaList,
                    method: 'get'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.deliveryareaList = res.data.data;
                    }
                });
            },
            getList(item) {
                let api;
                if(item != null){
                    api = this.$Api.deliveryareaConfigTimeList + '?did=' + item;
                }else{
                    api = this.$Api.deliveryareaConfigTimeList;
                }

                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: api,
                    method: 'get',
                    data:{
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {

                            tempArr.push({
								id: resData[i].id,
                                did: resData[i].did,
                                time: resData[i].time,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            handleToAdd() {
                this.isShowModalSign_goods = true;
            },
            handleEdit(item) {
                let id = item.id;
                let did = item.did;
                let time = item.time;

                if (time === '' || time === null) {
                   this.$Utils.showTipInfo('請選擇時間數組');
                   return;
                }

               this.isSubmiting = true;

               this.$Rq.requestAuth({
                  url: this.$Api.deliveryareaConfigTimeEdit,
                  method: 'post',
                  data: {
                   id: id,
                   did: did,
                   time: time,
                  }
               }).then((res) =>
               {
                  this.isSubmiting = false;
                  
                  if (res.code == 0)
                  {
                     this.$Utils.showSuccess(res.msg);
                     if(this.pageParam.id == undefined || this.pageParam.id == "") {
                         this.getList();
                    }
                    else {
                        this.getList(this.pageParam.id);
                    }
                  } else
                  {
                     this.$Utils.showTipInfo(res.msg);
                     if(this.pageParam.id == undefined || this.pageParam.id == "") {
                         this.getList();
                    }
                    else {
                        this.getList(this.pageParam.id);
                    }
                  }
               }).catch((err) =>
               {
                  this.isSubmiting = false;
               });
            },
			handleDelete(index) {
			    this.$Modal.confirm({
			        title: '提示',
			        content: '確定刪除嗎？',
			        cancelText: '取消',
			        okText: '確定',
			        onOk: () => {
			            let tableData = this.table.data;
			            this.isSubmiting = true;
			            this.$Rq.requestAuth({
			                url: this.$Api.deliveryareaConfigTimeDelete,
			                method: 'post',
                            data:{
                                id:index
                            }
			            }).then((res) => {
			                this.isSubmiting = false;
			                if (res.code == 0) {
			                    this.$Utils.showSuccess(res.msg);
			                    if(this.pageParam.id == undefined || this.pageParam.id == "") {
                                     this.getList();
                                }
                                else {
                                    this.getList(this.pageParam.id);
                                }
			                } else {
			                    this.$Utils.showTipInfo(res.msg);
			                }
			            }).catch((err) => {
			                this.isSubmiting = false;
			            });
			        }
			    });
			},
            handleModalSignClose_goods(){
                this.isShowModalSign_goods = false;
            },
            handleCheckForm() {
                let form = this.form;
                if (form.did === '') {
                   this.$Utils.showTipInfo('請輸入專線名稱');
                   return;
                } else if (form.time === '' || form.time === null) {
                   this.$Utils.showTipInfo('請選擇時間數組');
                   return;
                }
                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                   url: this.$Api.deliveryareaConfigTimeAdd,
                   method: 'post',
                   data: {
                      did: form.did,
                      time: form.time,
                   }
                }).then((res) => {
                   this.isSubmiting = false;

                   if (res.code == 0) {
                      this.$Utils.showSuccess(res.msg);
                      this.form = {
                        did: '',
                        time: '',
                      };
                      this.handleModalSignClose_goods();
                      if(this.pageParam.id == undefined || this.pageParam.id == "") {
                             this.getList();
                        }
                        else {
                            this.getList(this.pageParam.id);
                        }
                   } else {
                      this.$Utils.showTipInfo(res.msg);
                   }
                }).catch((err) => {
                   this.isSubmiting = false;
                });
            },
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                }
                else {
                    this.getList(this.pageParam.id);
                }
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                }
                else {
                    this.getList(this.pageParam.id);
                }
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                }
                else {
                    this.getList(this.pageParam.id);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'deliveryareanotdutySetting.scss';
</style>